export class GetCountryList {
  static readonly type = '[COUNTRY] Get Country';
}
